'use client';

import { useEffect, useState } from 'react';

import { AnimatedCounter } from 'react-animated-counter';

import { Palette } from 'DesignSystem2/Theme';

interface AnimatedProjectionTextProps {
    text: string;
    fontSize?: string;
    numberScrollAnimation: boolean;
    hideInitialAnimation?: boolean;
}

export const AnimatedProjectionText = ({
    text,
    fontSize,
    numberScrollAnimation,
    hideInitialAnimation = true,
}: AnimatedProjectionTextProps) => {
    // Hack to hide the initial animation on page load
    const [hideAnimation, setHideAnimation] = useState(hideInitialAnimation);

    useEffect(() => {
        setTimeout(() => setHideAnimation(false), 1000);
    }, []);

    if (!numberScrollAnimation) return <span>{text}</span>;

    return (
        <div className="flex items-center font-feature-number">
            {[...text].map((char, index) => {
                const parsedChar = parseInt(char);
                const key = `animated-counter-${index}-${char}`;

                if (isNaN(parsedChar))
                    return (
                        <div key={key}>
                            {/* A whitespace-only flex item collapses to zero width, so spaces
                                in the text (e.g. "172 companies") need a non-breaking space. */}
                            <span>{char === ' ' ? '\u00A0' : char}</span>
                        </div>
                    );

                return (
                    <div className="grid" key={key}>
                        {hideAnimation && <div style={{ gridColumn: 1, gridRow: 1 }}>{char}</div>}
                        <div style={{ opacity: hideAnimation ? 0 : 1, gridColumn: 1, gridRow: 1 }}>
                            <AnimatedCounter
                                key={`${index}-${parsedChar}`}
                                value={parsedChar}
                                includeDecimals={false}
                                incrementColor={Palette.Text.x10}
                                decrementColor={Palette.Text.x10}
                                fontSize={fontSize}
                                color="inherit"
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    );
    // Break down by unit into animated blocks
};
